import Promise from 'Promise';
import LocaleStore from '@get-bridge/learn-legacy-shared/dist/stores/LocaleStore';
import NotificationStore from './notifications/stores/NotificationStore';
import PerformSettingsStore from './perform_settings/stores/performSettingsStore';
import TaskStore from './tasks/stores/TaskStore';
import UserStore from './users/stores/UserStore';

function shouldRefetch(props, nextProps) {
  if (!props.currentUserInfo) return true;
  if (!nextProps.currentUserInfo) return false;

  return props.currentUserInfo.id !== nextProps.currentUserInfo.id;
}

const LTI_PLACEMENTS = ['learner_nav', 'admin_nav'];

export default function(productEnabled, ltiPlacementStore) {
  const props = {
    locales: {
      fetch() {
        return LocaleStore.fetchAll();
      },

      get() {
        return LocaleStore.getAll();
      },

      setup(onChange) {
        LocaleStore.addChangeListener(onChange);
      },

      teardown(onChange) {
        LocaleStore.removeChangeListener(onChange);
      },
    },
    ltiPlacements: {
      get() {
        return ltiPlacementStore.getAll(LTI_PLACEMENTS);
      },

      fetch() {
        return ltiPlacementStore.fetchAll(LTI_PLACEMENTS);
      },

      shouldRefetch(prevProps, nextProps) {
        return (
          ltiPlacementStore.clearedWithoutFetch ||
          !ltiPlacementStore.finishedFetch ||
          shouldRefetch(prevProps, nextProps)
        );
      },

      setup(onChange) {
        ltiPlacementStore.addChangeListener(onChange);
      },

      teardown(onChange) {
        ltiPlacementStore.removeChangeListener(onChange);
      },
    },
    performSettings: {
      setup(onChange) {
        PerformSettingsStore.addChangeListener(onChange);
      },

      teardown(onChange) {
        PerformSettingsStore.removeChangeListener(onChange);
      },

      shouldRefetch,

      fetch() {
        return PerformSettingsStore.fetchAll();
      },

      get() {
        return PerformSettingsStore.getAll();
      },
    },
  };

  if (!productEnabled('perform')) return props;

  return {
    ...props,
    notifications: {
      setup(onChange) {
        NotificationStore.addChangeListener(onChange);
      },

      teardown(onChange) {
        NotificationStore.removeChangeListener(onChange);
      },

      shouldRefetch,

      fetch() {
        return NotificationStore.fetchAll();
      },

      get() {
        return {
          notifications: NotificationStore.getAll(),
          fetchStatus: TaskStore.fetchStatus,
        };
      },
    },
    tasks: {
      setup(onChange) {
        TaskStore.addChangeListener(onChange);
      },

      teardown(onChange) {
        TaskStore.removeChangeListener(onChange);
      },

      shouldRefetch,

      fetch() {
        return TaskStore.fetchAll();
      },

      get() {
        return {
          tasks: TaskStore.getAll(),
          createStatus: TaskStore.createStatus,
          saveStatus: TaskStore.updateStatus,
          deleteStatus: TaskStore.deleteStatus,
          fetchStatus: TaskStore.fetchStatus,
        };
      },
    },
    teammates: {
      setup(onChange) {
        UserStore.addChangeListener(onChange);
      },

      teardown(onChange) {
        UserStore.removeChangeListener(onChange);
      },

      shouldRefetch,

      fetch(props) {
        const { isManager, id: userId, managerId } = props.currentUserInfo;

        if (isManager) {
          return UserStore.fetchDirectReports(userId);
        }
        return UserStore.fetchDirectReports(managerId);
      },

      get() {
        return {
          teammates: UserStore.getSearchResults(),
          searchStatus: UserStore.searchStatus,
          directReports: UserStore.getDirectReports(),
        };
      },
    },
    manager: {
      setup(onChange) {
        UserStore.addChangeListener(onChange);
      },

      teardown(onChange) {
        UserStore.removeChangeListener(onChange);
      },

      shouldRefetch,

      fetch(props) {
        const { managerId } = props.currentUserInfo;
        if (managerId) {
          return UserStore.fetchManager(managerId);
        }
        return Promise.resolve();
      },

      get(props) {
        if (!props.currentUserInfo) return null;

        return UserStore.getManager(props.currentUserInfo.managerId);
      },
    },
  };
}



// WEBPACK FOOTER //
// ./packages/bridge-global-nav/src/buildAsyncProps.js